import React from 'react'

import { TableEditButton } from 'components/Table'

const EditContactButton = props => (
  <TableEditButton type='button' {...props} />
)

export default EditContactButton
